import { useDispatch, useSelector } from "react-redux";
import { RootState } from "services/store";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { usePdfViewer } from "context/PdfViewerContext";
import { useTranslation } from "react-i18next";
import "./BottomSheetDialogOcr.css";
import { OcrDataPage, setOcrData } from "features/appStateSlice";
import OcrBtn from "../OcrBtn/OcrBtn";
import Draggable from 'react-draggable';

const BottomSheetDialogOcr = ({ ocrEnabled, generateOcr }: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pdfViewer } = usePdfViewer();
  const ocrData = useSelector((state: RootState) => state.appState.ocrData);

  if (!pdfViewer) return null;
  if (!ocrData) return null;
  if (!ocrData.selectedPage) return null;
  if (!ocrData.pages) return null;

  const closeNavigator = () => {
    let newOcrData = structuredClone(ocrData);
    newOcrData.selectedPage = undefined;
    dispatch(setOcrData(newOcrData));
  };
  
  const ocrDataPage = ocrData.pages.filter(
    (page) => page.pageNumber == ocrData.selectedPage
  );

  if (ocrDataPage.length == 0) return null;

  return (
    <>
      <Draggable handle=".draggable">
        <Box
          sx={{
            position: "relative",
            bottom: 0,
            zIndex: 1000,
            bgcolor: "background.paper"
          }}
        >
          <Box
            sx={{
              position: "absolute",
              boxShadow: 2,
              bgcolor: "background.paper",
              width: "70%",
              left: "15%",
              bottom: 24,
              display: "block"
            }}
          >
            <Box 
              className="draggable" 
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                pl: 3,
                pt: 3,
                pr: 2,
                pb: 2,
                backgroundColor: "#366193",
                color: "white",
                cursor: "move"
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="body1"
                  sx={{ fontWeight: "bold", display: "inline" }}
                >
                  {t("bottomSheet.textContent")}
                </Typography>
                <Typography variant="caption" sx={{ display: "inline", ml: 1 }}>
                  {t("bottomSheet.page")} {ocrDataPage[0].pageNumber}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                { ocrEnabled && (<OcrBtn color="pink" generateOcr={generateOcr} />) }
                <Tooltip title={t("tooltip.close")} arrow placement="top">
                  <IconButton onClick={closeNavigator} sx={{ color: "white" }}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Box
              sx={{
                px: 3,
                py: 2,
                bgcolor: "background.paper",
                borderTop: "1px solid #ddd",
                borderBottom: "1px solid #ddd",
                maxHeight: "45vh",
                overflow: "auto"
              }}
            >
              <Box>
                {ocrDataPage.map(
                  (item: OcrDataPage, index: number) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "start",
                        mb: 1,
                      }}
                    >
                      <div>
                        <p dangerouslySetInnerHTML={{ __html: item.text }} />
                      </div>
                    </Box>
                  )
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Draggable>
    </>
  );
};

export default BottomSheetDialogOcr;
